import React from 'react';

const TimeframeSelector = ({ onTimeframeChange, selectedTimeframe, timeRange }) => {
  // Function to handle changes in timeframe selection
  const handleChange = (event) => {
    onTimeframeChange(event.target.value);
  };

  // Determine the options' availability based on the timeRange
  const isDisabled = (option) => {
    if (option === 'day' && timeRange === '24h') return true;
    if (option === 'week' && (timeRange === '24h' || timeRange === '7d')) return true;
    return false;
  };

  return (
    <div className="flex space-x-2 md:mr-8">
      <select
        value={selectedTimeframe}
        onChange={handleChange}
        className="py-2 px-4 text-sm font-medium rounded bg-white text-gray-700"
      >
        <option value="hour" className="text-gray-700">
          By Hour
        </option>
        <option value="day" disabled={isDisabled('day')} className="text-gray-700">
          By Day
        </option>
        <option value="week" disabled={isDisabled('week')} className="text-gray-700">
          By Week
        </option>
      </select>
    </div>
  );
};

export default TimeframeSelector;
